import { useTranslation } from 'react-i18next';

import { Box, Checkbox, HStack, Skeleton, Text, useToast, VStack } from '@bonusly/design-system';

import { useBizyMomentEmailPreferences, useUpdateBizyMomentEmailPreferencesMutation } from '../../queries/bizy-moment-email-preferences';

export const MomentEmailsSection = () => {
	const { t } = useTranslation('bizy_settings', { keyPrefix: 'momentEmails' });
	const { t: tSettings } = useTranslation('bizy_settings');
	const toast = useToast();
	const { data, isLoading } = useBizyMomentEmailPreferences();
	const { mutate: updatePreference, isLoading: isUpdating } = useUpdateBizyMomentEmailPreferencesMutation();

	const handleChange = (nextEnabled: boolean) => {
		if (!data || nextEnabled === data.momentEmailsEnabled) return;

		updatePreference(
			{ momentEmailsEnabled: nextEnabled },
			{
				onSuccess: () => {
					toast({ title: tSettings('saveBar.saved'), status: 'success', duration: 2500 });
				},
				onError: () => {
					toast({ title: t('updateError'), status: 'error', duration: 3000 });
				},
			}
		);
	};

	return (
		<VStack spacing={2} align="stretch">
			<HStack justify="space-between" align="start" spacing={4}>
				<Text flex="1" size="sm" variant="medium" color="text.default">
					{t('columnNotification')}
				</Text>
				<Text w="80px" textAlign="center" size="sm" variant="medium" color="text.default" flexShrink={0}>
					{t('columnEmail')}
				</Text>
			</HStack>
			<Box borderBottom="1px solid" borderColor="border.soft" />

			<Box>
				<HStack justify="space-between" align="start" spacing={4} py={1}>
					<VStack flex="1" align="start" spacing={1} minW={0}>
						<Text size="md" variant="strong" color="text.default">
							{t('label')}
						</Text>
						{!isLoading && !data ? (
							<Text size="sm" color="text.softer">
								{t('loadError')}
							</Text>
						) : (
							<Text size="sm" color="text.default">
								{t('description')}
							</Text>
						)}
					</VStack>
					<HStack w="80px" h="12" justify="center" align="center" flexShrink={0}>
						{isLoading ? (
							<Skeleton h="5" w="5" borderRadius="md" />
						) : data ? (
							<Checkbox
								aria-label={t('toggleAriaLabel')}
								isChecked={data.momentEmailsEnabled}
								isDisabled={isUpdating}
								colorScheme="blue"
								size="md"
								onChange={(event) => handleChange(event.target.checked)}
							/>
						) : null}
					</HStack>
				</HStack>
				<Box borderBottom="1px solid" borderColor="border.soft" mt={3} />
			</Box>
		</VStack>
	);
};
